import * as React from "react"
import { useEffect } from "react"

export const LocationRedirect: React.FC<{ href: string }> = (props) => {
  useEffect(() => {
    window.location.href = props.href
  }, [])
  return <div />
}
